import { render, staticRenderFns } from "./ModalTermsAcceptanceReminder.vue?vue&type=template&id=7b7e2c9d"
import script from "./ModalTermsAcceptanceReminder.vue?vue&type=script&lang=js"
export * from "./ModalTermsAcceptanceReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7e2c9d')) {
      api.createRecord('7b7e2c9d', component.options)
    } else {
      api.reload('7b7e2c9d', component.options)
    }
    module.hot.accept("./ModalTermsAcceptanceReminder.vue?vue&type=template&id=7b7e2c9d", function () {
      api.rerender('7b7e2c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/views/accounts/AccountView/Settings/ModalTermsAcceptanceReminder.vue"
export default component.exports